import cn from 'classnames'
import styles from './styles.module.scss'

interface IProps {
    isStopped: boolean
}

export const MovingVerticalDots = ({ isStopped }: IProps) => {
    const dots = Array.from({ length: 6 }, (_, i) => (
        <div key={i} className={styles.dotVertical} />
    ))

    return (
        <div className={styles.dotsVerticalContainer}>
            <div
                className={cn(styles.dotsTrackVertical, {
                    [styles.animateVertical]: !isStopped,
                })}
            >
                <div className={styles.dotsGroupVertical}>{dots}</div>
                <div className={`${styles.dotsGroupVertical} ${styles.second}`}>
                    {dots}
                </div>
            </div>
        </div>
    )
}
